module.exports = __webpack_public_path__ + "static/media/30OIOS4.dd6f88d3.jpg";